import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-ios',
  templateUrl: './download-ios.component.html',
  styleUrls: ['./download-ios.component.css']
})
export class DownloadIosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
